<template>
  <v-tooltip left :color="colors['bright-green']">
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs" v-if="show" class="notification-number">
        {{ itemsNumber }}
      </span>
    </template>
    <span>All Notifications</span>
  </v-tooltip>
</template>

<script>
import colors from "@/assets/sass/_variables.sass"
export default {
  name: "NotificationCircle",
  data() {
    return {
      colors,
    }
  },
  computed: {
    show() {
      return this.itemsNumber && this.itemsNumber > 0
    },
    itemsNumber() {
      return this.$store.getters["teamList/allNotificationsCount"]
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/_variables.sass'
.notification-number
  background-color: $orange
  border-radius: 100%
  color: $white
  display: inline-block
  font-size: 9px
  font-weight: 600
  height: 18px
  line-height: 18px
  position: relative
  align-self: flex-end
  text-align: center
  vertical-align: middle
  width: 18px
</style>
